module.exports = __webpack_public_path__ + "static/img/cCT8.2e9ba6f5.png";